module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_5.e0e0baf6.png";